import React from 'react';
import './MetricSwitcher.scss';
import { useTranslation } from 'react-i18next';

export interface MetricSwitcherOption<K extends string> {
  key: K;
  labelKey: string;
}

interface MetricSwitcherProps<K extends string> {
  options: ReadonlyArray<MetricSwitcherOption<K>>;
  value: K;
  onChange: (key: K) => void;
}

/**
 * Segmented switcher: one active pill in a section title row. Born on Insights (prompt matrix, competitor
 * funnel over time — three/four metrics), reused by the Agency Hub as the projects status filter. The
 * caller owns the option list and the state.
 */
const MetricSwitcher = <K extends string>({ options, value, onChange }: MetricSwitcherProps<K>) => {
  const { t } = useTranslation();

  return (
    <div className="metric-switcher">
      {options.map(({ key, labelKey }) => (
        <button
          key={key}
          type="button"
          aria-pressed={value === key}
          className={`metric-switcher__option${value === key ? ' metric-switcher__option--active' : ''}`}
          onClick={() => onChange(key)}
        >
          {t(labelKey)}
        </button>
      ))}
    </div>
  );
};

export default MetricSwitcher;
